import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import {
  AndroidDubaiLangtIcon,
  AndroidDubaiIDEIcon,
  AndroidDubaiToolstIcon,
  AndroidDubaiFrameIcon,
} from "../../../app-constants";

const StackItem = [
  {
    icon: AndroidDubaiLangtIcon,
    title: "Android App Development Languages",
    description: "Java, Kotlin, JavaScript, XML",
  },
  {
    icon: AndroidDubaiIDEIcon,
    title: "IDE",
    description: "Android Studio",
  },
  {
    icon: AndroidDubaiToolstIcon,
    title: "Development Tools",
    description: "Android SDK, Android NDK",
  },
  {
    icon: AndroidDubaiFrameIcon,
    title: "Frameworks",
    description: "RetroFit, React Native, Dagger2, Rails, Gradle, Volley",
  },
];

function Technology(props) {
  return (
    <div className="technoloy_sec p-100">
      <Container className="h-100">
        <Row className="h-100">
          <Col xs={12} md={6} lg={6} xl={5} xxl={5} className="">
            <div className="example" data-text="Tech">
              <h2>Technologies We Use for Android App Development in Dubai</h2>
            </div>
          </Col>
          <Col
            xs={12}
            md={6}
            lg={6}
            xl={6}
            xxl={6}
            className="my-auto offset-xl-1"
          >
            <p>
              As one of the top Android app development companies in Dubai, we
              use a variety of effective tools to satisfy your specific needs.
            </p>
          </Col>
          <Col xs={12} md={12} lg={12} xl={11} xxl={11} className="m-auto">
            <div className="technology_main">
              {StackItem.map((item, index) => (
                <div className="technology_item">
                  <div className="svg_icon">{item.icon}</div>
                  <h6>{item.title}</h6>
                  <p>{item.description}</p>
                </div>
              ))}
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default Technology;
